const importClueData = [
    [],
    [
        {
            id: 0,
            name: "Photo Identities",
            total: 4,
            clues: [
                    "Hover your mouse over each of the suspect photos on screen, Larry has info about each of them. Can you use that info to work out which suspect is which on pages 2 to 5? Don’t forget to stick in the suspect’s photo and fill in the blanks!",
                
                    "Nigel was born 12th July 1986. Can you use the newspaper on page 1 of your investigation files to work out how old he is?",
                
                    "Harriette has eyes the same color as the museum entrance hall seats. Listen to Larry’s recording by clicking the Play Recording button to find out what color they are. If you request another clue for this puzzle you will receive the full solution.",
                
                    "Logan is the journalist. Harriette is the curator’s assistant. Nigel is the museum curator. Dorris is the museum shopkeeper. Mary is the security guard. Tara is the archeologist. Bruce is the philanthropist." 
                   ],
            visible: true
        },
        {
            id: 1,
            name: "Matching The Key",
            total: 2,
            clues: [
                    "There is an image of a key somewhere in your investigation file. Click on the arrows on screen to find the matching top, middle and bottom which matches that key.",
                
                    "Click on the arrows to find the matching top, middle and bottom which matches the key on page 21",
                
                    "Click on the arrows to find the matching top, middle and bottom which matches the key on page 21",
                
                    "Click on the arrows to find the matching top, middle and bottom which matches the key on page 21", 
                   ],
            visible: true
        },
        {
            id: 2,
            name: "Picking The Lock",
            total: 4,
            clues: [
                    "The outer rim of the lock is the same as the circle on page 21 of your investigation files. Can you use that page to work out where your lock picks should go?",

                    "Use the two grids on page 21. Can you colour in the correct number of black squares in each row/column to get two symbols?", 

                    "On page 21, if the number at the edge of a row/column is 5 then you know that every square in that row/column should be shaded black. Use that as your starting point to fill out each grid. Once you know the symbols drag the sliders on screen to move the lockpicks into the correct zones. If you request another clue for this puzzle you will receive the full solution.",

                    "Put both lockpick sliders as far to the left as they can go. Lockpick One should go in the sixth zone counting clockwise. Lockpick Two should go in the first zone counting clockwise.",
                   ],
            visible: false
        },
    ],
    [
        {
            id: 0,
            name: "Check-In Sheet",
            total: 4,
            clues: [
                    "The latest evidence files include pieces of Dorris’ check in sheet. You will need to piece these together to help you work out who was in the building at the time of the robbery.",

                    "The ticket numbers on Dorris’ check-in sheet all go on the left hand side. Can that help you put the check-in sheet together correctly?",

                    "Once the check-in puzzle is complete, use Larry’s timeline on screen to find out when the diamond was taken. Can you work out which ticket number was not in the building at the time of the robbery? If you request another clue for this puzzle you will receive the full solution.",

                    "Ticket #271825 was not in the building at the time of the robbery.",
                   ],
            visible: true
        },
        {
            id: 1,
            name: "The Cloakroom Code",
            total: 4,
            clues: [
                    "Page 6 and the note at the bottom of Dorris’ check in sheet will help you crack the cloakroom code. Can you use the three examples to work out Dorris’ system and fill in the ticket number for each suspect?",

                    "The ticket number for each suspect is based on the items they have checked in. Dorris has split these items into 4 categories and each category has a number. The number for ‘garments’ is 8, can you use this and the three examples on page 6 to work out how each ticket number is constructed?",

                    "Dorris has four categories of items: garments, bags, worn accessories and carried items. The first example on page 6, in order, has 3 ‘worn accessories’ (7), 1 ‘garment’ (8) and 1 ‘carried item’ (3). Hence the ticket number is 371813. The value for ‘bags’ is 5.  If you request another clue for this puzzle you will receive the full solution.",

                    "Tara’s ticket number is 152317. Harriette’s ticket number is 282723. Bruce’s ticket number is 232817. Nigel’s ticket number is 183327. Mary’s ticket number is 271315. Logan’s ticket number is 271825.",
                   ],
            visible: true
        },
    ],
    [
        {
            id: 0,
            name: "Unlocking The Desk",
            total: 4,
            clues: [
                    "The desk switches have three positions: circle, triangle, or trapeze. Have you seen those shapes anywhere else?",

                    "You will find the desk shapes on Nigel’s books when you search the bookcase. Can you find something in your investigation file to tell you which order those books come in?",

                    "The “Book Club Reading List” is on page 18. The first book in that list relates to the top switch on screen. Can you use this to help you set the desk switches? If you request another clue for this puzzle you will receive the full solution.",

                    "From top to bottom the switches are: trapeze, triangle, circle, trapeze, circle.",
                   ],
            visible: true
        },
        {
            id: 1,
            name: "The Painting",
            total: 3,
            clues: [
                    "Inside the desk you found something which can help you with the painting.", 

                    "Inside the desk you found a photo of a part of the painting. Can you find that exact bit of the painting?",

                    "The picture you found in the desk had the words “Press There” on it. When you have found the part of the painting which matches the picture click there.",
                
                    "The picture you found in the desk had the words “Press There” on it. When you have found the part of the painting which matches the picture click there.",
                   ],
            visible: false
        },
        {
            id: 2,
            name: "Unlocking The Safe",
            total: 4,
            clues: [
                    "The eye in the centre of the safe looks familiar. Where have you seen it before?",

                    "You will find the same eye in your investigation file. Look closely and you will see an instruction which will help you find the safe code.",

                    "On page 7 there is a picture of an eye with the word tilt. Tilt this page. When it is at the right angle you will see the safe code. If you request another clue for this puzzle you will receive the full solution.",

                    "The safe code is 7263.",
                   ],
            visible: false
        },
        {   
            id: 3,
            name: "Decoding The Thumb",
            total: 4,
            clues: [
                    "Can you use Page 9 to translate each suspect’s thumb symbol and color? Your answer should be a number followed by a letter.",

                    "In the examples on page 9, each symbol translates to a number and each color translates to a letter. Can you spot the similarities in the examples to work out what each suspect’s thumb symbol and color translate to?",

                    "On page 9 you will see two examples with a color of GREEN which translate to a number followed by A. Therefore GREEN = A. The two BLUE examples translate to a number followed by M. So BLUE = M. Can you spot other similarities in the examples to work out what each symbol and color translate to? If you request another clue for this puzzle you will receive the full solution.",

                    "Nigel’s thumb is 2X. Tara’s thumb is 2X. Bruce’s thumb is 7A. Harriette’s thumb is 3X. Mary’s thumb is 2X.",
                   ],
            visible: true
        },
        {
            id: 4,
            name: "Decoding The Index Finger",
            total: 4,
            clues: [
                    "Pages 10 and 11 of your investigation files will help you decode the index finger of each suspect.",

                    "Follow the route from each starting point at the edge of the map on page 11 to find out what each color and symbol translates to.",

                    "Once you have followed each maze route and know what each color and symbol leads to, you can translate each of the suspects index fingers into a 2 character code. Make sure to follow the instruction on page 11; ‘color followed by symbol’. If you request another clue for this puzzle you will receive the full solution.",

                    "Nigel’s index is 8T. Tara’s index is 84. Bruce’s index is 87. Harriette’s index is 6T. Mary’s index is GH.",
                   ],
            visible: true
        },
        {
            id: 5,
            name: "Decoding The Middle Finger",
            total: 4,
            clues: [
                    "Use the two tables on Page 14 to translate each suspect’s middle finger.",

                    "On page 14, start by checking if the suspect's middle finger symbol appears anywhere else in that fingerprint sequence. If it does then use the top table. If it doesn’t then use the bottom table.",

                    "Identify which table you need to use then look at the color of the suspect's middle finger and color of the thumb. Find the row and column of these colours, The point at which they intersect is the suspect’s middle finger code. If you request another clue for this puzzle you will receive the full solution.",

                    "Nigel’s middle is Q7. Tara’s middle is 5Y. Bruce’s middle is QR. Harriette’s middle is QN. Mary’s middle is QY.",
                   ],
            visible: true
        },
        {
            id: 6,
            name: "Decoding The Fourth Finger",
            total: 4,
            clues: [
                   "You will need three pages of your investigation file to translate the fourth finger. Start with page 15. That should help you identify the other two pages you need. The answer will be a single character.",

                    "On page 15, use the color and symbol of the suspect’s fourth finger to identify which quarter of the grid they fall into. Each quarter is represented by a shape. On page 20 you will see those same shapes next to a list of coordinates. Pages 16 and 17 feature blank graphs. Plot each shape’s coordinates onto a different graph.",

                    "Once you have linked each suspect to a shape (hearts, diamonds, clubs, spades) and plotted each shape’s coordinates onto a graph, draw a line between each coordinate in order and you will see you have drawn a number. Therefore SUSPECT = SHAPE = NUMBER. If you request another clue for this puzzle you will receive the full solution.",
                
                    "Nigel’s fourth finger is 9. Tara’s fourth finger is 6. Bruce’s fourth finger is 9. Harriette’s fourth finger is 4. Mary’s fourth finger is 3." 
                   ],
            visible: true
        },
        {
            id: 7,
            name: "Decoding The Fifth Finger",
            total: 4,
            clues: [
                    "Using the venn diagram on screen and page 19 can you translate each suspect’s fifth finger?",

                    "Each oval on the venn diagram represents a statement. If the statement is true then you need a section inside that oval. If the statement is false then the section must be outside that oval. For example if the colour is blue, the symbol is repeated in its own sequence AND the symbol has a spiral it falls into the section labelled ‘Beta’.",

                    "Once you have identified which section a suspect sits in then you can use page 19 to translate the greek letters on screen and identify the 2 character code. If you request another clue for this puzzle you will receive the full solution.",

                    "Nigel’s fifth finger is B2. Tara’s fifth finger is 65. Bruce’s fifth finger is J5. Harriette’s fifth finger is 85. Mary’s fifth finger is J9.",
                   ],
            visible: false
        },
        
    ],
    [
         {
            id: 0,
            name: "The Coded Letter",
             total: 4,
            clues: [
                    "On page 23 of your investigation files you will find the coded letter. The symbols look a lot like those on the decoder wheel in your latest evidence pack.",

                    "In your latest evidence pack you have a decoder wheel in two parts. Can you find something in your investigation file to help you correctly line up the decoder?",

                    "On page 5 you will see that one of the decoder symbols equals P. Line up the decoder wheels so that this is true and you will have a letter for each symbol. Use this to translate the coded letter. If you request another clue for this puzzle you will receive the full solution.",

                    "The coded letter says: ‘Come to see me. Click the second bar down like this one’. Check the coded letter to see an example of the bar and then click the correct bar on screen.",
                   ],
            visible: true
        },
        {
            id: 1,
            name: "Jack's Game",
            total: 4,
            clues: [
                    "Time limit extended to 75 seconds",
                    "Time limit extended to 90 seconds",
                    "Time limit extended to 105 seconds",
                    "The time limit has been removed" 
                   ],
            visible: false
        },
        {
            id: 2,
            name: "The Temperature",
            total: 4,
            clues: [
                    "After you have clicked ‘Run Analysis’ on screen, the first part of the formula code can be worked out using the temperature display on screen, page 5 and page 12.",

                    "Page 5 shows that each row provides either a letter or a number. Can you use the three examples on page 12 to work out what letter/number each dot represents. Then you can use that information to decode the temperature display on screen into a four character code.",

                    "Start from the bottom row. The first and third row give you a letter. The second and fourth row give you a number. No number is higher than 4. No letter is beyond D. If you request another clue for this puzzle you will receive the full solution.",

                    "Starting with the bottom row. Each dot on the first and third rows, from left to right is: A, B, C, D. Each dot in the second and fourth rows, from left to right is: 1, 2, 3, 4. Therefore the first part of the formula is ‘B2A4’. ",
                   ],
            visible: false
        },
        {   
            id: 3,
            name: "The Time",
            total: 4,
            clues: [

                "Click ‘Run Analysis’ on screen. To work out the second part of the formula code you will need pages 12 and 22. Make sure to start at the right time on the periodic table.",	

                "The time taken for the analysis is 12 seconds. Start at the block labelled 12 on the periodic table.",

                "Start at the block labelled 12 on the periodic table and follow the arrow directions shown on page 12. Where you end will be the two letters you need. If you request another clue for this puzzle you will receive the full solution.",

                "The second part of your formula code is ‘Sr",
                   ],
            visible: false
        },
        {
            id: 4,
            name: "The Colour Bars",
            total: 4,
            clues: [
                    "Click ‘Run Analysis’ on screen. To work out the third part of the formula code you will need page 13. Find the combination of coloured bars which matches the image on screen?",

                    "On page 13 there are pink and blue bars like those on screen. Can you work out which three images in your investigations files, when layered together, would match the image on screen?",

                    "Once you have identified which three images on page 13 layer together to match the image on screen, use the code written beneath each one for your formula code. Make sure to enter these pieces of code alphabetically. If you request another clue for this puzzle you will receive the full solution.",
                
                    "The three images which when layered on top of each other would match the image on screen are: H2, K2 and Ca. When put together in alphabetical order the code becomes: CaH2K2." 
                   ],
            visible: false
        },
    ],
    [
        {
            id: 0,
            name: "The Blueprint Puzzle",
            total: 4,
            clues: [
                    "In your investigation file you received a page labelled ‘The City Museum Blueprint’. Throughout your investigation you have received the blueprint rooms of the museum. Listen again to all of Larry’s recordings and see if you can fit the pieces together like a jigsaw puzzle.",

                    "The Staff Office sits to the left of the Entrance Hall and the Shop sits to the right of the Entrance Hall. The W.C. sits on the right, next to the Shop.",

                    "The East Wing is accessed from the Entrance Hall on the right and the West Wing is accessed from the Entrance Hall on the left. Once you have placed all the rooms have a listen to Larry’s recording in part 5 to hear where the vent opening is.",

                    "The vent tile creates an opening between the Store Room and the Diamond Room. Line up the white circles on the vent tile with the white circles on the room walls for its exact position.",

                   ],
            visible: true
        },
        {
            id: 1,
            name: "People's Locations",
            total: 4,
            clues: [
                    "Can you use your pages 2 to 5 and the images on screen to discover where each suspect was at the time of the robbery? You may find it helpful to write on your blueprint once you know the location.",
 
                    "On pages 2 to 5, each suspect has an icon assigned to them - for example Dorris’ icon is a coat hanger. Use the images on screen to work out where each suspect was and write this on the blueprint you have created.",

                    "Look for unique shapes or objects in the images on screen, where do these appear on the blueprint? Make sure it exactly matches the one on screen. If you request another clue for this puzzle you will receive the full solution.",
                
                    "Bruce is in the West Wing. Dorris is in the Shop. Harriette is in the Courtyard. Logan is outside the museum entrance. Mary is in the Curator’s Office. Nigel is in the Main Exhibition Hall. Tara is in the Staff Office." 
                   ],
            visible: true
        },
        {
            id: 2,
            name: "The Route Code",
            total: 4,
            clues: [
                    "As part of your latest evidence pack you received a sheet with the room names on the left and numbers on the right. Can you use this sheet to work out the number for each room? Then use the number from each room on the criminal’s route.",

                    "The word CUT is highlighted in orange and underlined with a dotted line. The same orange dotted line runs down the middle of the sheet. Cut down that line and use the same method for FOLD and HOLE.",

                    "Once you have cut along the orange line, folded along the green lines and made a hole in the pink circles, you can layer the room names on top of the numbers and see through to the number which links to each room. Only one suspect can get to the diamond without being seen. If you request another clue for this puzzle you will receive the full solution.",

                    "The only suspect who can reach the diamond without being seen by another suspect is Tara. Her route is: Staff Office (9), Entrance Hall (5), East Wing (3), Restoration Room (2), Store Room (8), Diamond Room (4). The route code is 953284.",
                   ],
            visible: true
        },
        {   
            id: 3,
            name: "Hideout Locations",
            total: 4,
            clues: [
                    "In the latest evidence pack you have a page from Tara’s journal. Can you use the numbers on screen and the poem in Tara’s journal to work out what words Tara is saying?",

                    "Each set of three numbers relates to a letter in Tara’s poem. The first number tells you which line the letter is on. The second number tells you which word in that line. The third number tells you which letter in that word. Can you spell out the words?",

                    "The words are grouped together into pairs on screen. Try saying them out loud together. You will find that each pair of words is a grid reference on the map. Click each correct grid reference. If you request another clue for this puzzle you will receive the full solution.",

                    "The grid references are B5, A6, C1.",
                   ],
            visible: false
        },
        {
            id: 4,
            name: "The Switches",
            total: 4,
            clues: [
                    "In your latest evidence pack you received a page of Tara’s journal. Can you use this to work out which direction each switch on screen should be set to?",

                    "Tara has a poem in her journal. Try reading it outloud and listen for directions. At the bottom of Tara’s journal page there is a diagram of the switches. This tells you which order to use the switches in.",

                    "List out everytime the words ‘up’ and ‘down’ are used in the poem. These are the directions for the switches.  Don’t forget to use them in the correct order. If you request another clue for this puzzle you will receive the full solution.",

                    "The switches should be set in the following directions. Top row (left to right): DOWN, DOWN, UP, DOWN, UP. Bottom Row (left to right): DOWN, UP, UP, DOWN, DOWN.",
                   ],
            visible: false
        },
        {
            id: 5,
            name: "The Briefcase",
            total: 4,
            clues: [
                    "In your latest evidence pack you received a page of Tara’s journal. There is a grid of letters on this page, starting at the arrow can you follow the letters through the grid to make six words?",

                   " The words in the grid seem familiar, check your ‘Investigation Log’",

                    "The words in the grid are the passwords for each part of the investigation and, if you followed Larry’s advice, you have written them in your ‘Investigation Log’. Use this to work out the briefcase code. If you request another clue for this puzzle you will receive the full solution.",

                    "The words in the grid, in order are: Liberty (password for part 1), Rogue (password for part 4), Indigo (password for part 2), Anvil (password for part 3), Justice (password for part 5), Indigo (password for part 2). The briefcase code is: 142 352.", 
                   ],
            visible: false
        },
    ],
    [],
    []
]

export default importClueData